module.exports = __webpack_public_path__ + "img/sysStore.328a70f7.png";